import { Box, Button, Typography } from '@mui/material';
import classNames from 'classnames';
import { memo } from 'react';
import LangEnum from '../../../../../../../../../../../lang/LangEnum';
import useTeceoStyles from '../../../../../../../../../../../useTeceoStyles';
import { getColorByRole } from '../../../../../../../../../../../utils/generics';
import { useApplicationContext } from '../../../../../../../../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../../../../../../../../translation/TranslationContext';
import { invertChatRole } from '../../../../../../../../../utils/chat.utils';
import ChatAvatar from '../../../../../../../../ChatAvatar/ChatAvatar';
import { useGroupedRoomItemStyles } from './groupedRoomItem.styles';
import { GroupedRoomItemProps } from './groupedRoomItem.types';

const GroupedRoomItem = ({
  onClick,
  groupName,
  groupImageSrc,
  chatWithNotificationCount,
}: GroupedRoomItemProps) => {
  const { translate } = useTranslation();
  const { classes: teceoClasses } = useTeceoStyles();
  const { isStore, userRole } = useApplicationContext();

  const hasNotification = chatWithNotificationCount > 0;

  const { classes: styles } = useGroupedRoomItemStyles({ hasNotification });

  return (
    <Button className={styles.button} onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px',
          alignItems: 'center',
        }}
      >
        <ChatAvatar
          size={4.5}
          src={groupImageSrc}
          title={groupName}
          backgroundColor={getColorByRole({
            withSrc: !!groupImageSrc,
            transparentWhenHasSrc: false,
            userRole: invertChatRole(false, isStore, userRole),
          })}
        />

        <Typography
          color="textPrimary"
          style={{ fontWeight: 700, textAlign: 'left' }}
          className={classNames(teceoClasses.noTextTransform, teceoClasses.truncateOneLine)}
        >
          {groupName}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {hasNotification && (
          <Typography color="primary">
            {chatWithNotificationCount > 1
              ? translate(LangEnum.CHAT_MESSAGES_UNREAD, {
                  unreadMessagesCount: chatWithNotificationCount,
                })
              : translate(LangEnum.CHAT_MESSAGES_UNREAD_ONE)}
          </Typography>
        )}
      </Box>
    </Button>
  );
};

export default memo(GroupedRoomItem);
